import axios from 'axios'

const stdContexts = {
  session: 'vksession/rest/',
  mediastorage: 'mediastorage/rest/',
  calendar: 'vkcalendar/rest/',
  reporter: 'reporter/rest/v2/',
  tracker: 'vktracker/rest/',
  group: 'vkgroup/rest/',
  buzzer: 'vkbuzzer/rest/',
  asr: 'vkvocabulary/rest/',
  security: 'security/rest/',
  tts: 'vktts/rest/v1/',
  tts2: 'vktts/rest/v2/',
  configurator: 'configurator/rest/',
  face: 'face-access/rest/',
  vkAgent: 'vkagent/rest/v3/',
  agent: 'demo/rest/v1/',
  accessDemo: 'access-demo/rest/'
}

const contexts = window.appSettings ? {
  ...stdContexts,
  ...window.appSettings.contexts
} : stdContexts

const hosts = window.appSettings ? {
  std: '',
  ...window.appSettings.hosts
} : { std: '' }

const getURL = URLType => (hosts[URLType] || hosts.std) + contexts[URLType]

const URL_TYPES = {
  SESSION: 'session',
  MEDIASTORAGE: 'mediastorage',
  CALENDAR: 'calendar',
  REPORTER: 'reporter',
  TRACKER: 'tracker',
  GROUP: 'group',
  SECURITY: 'security',
  AGENT: 'agent',
  BUZZER: 'buzzer',
  ASR: 'asr',
  TTS: 'tts',
  TTS2: 'tts2',
  CONFIGURATOR: 'configurator',
  FACE: 'face',
  VK_AGENT: 'vkAgent',
  ACCESS_DEMO: 'accessDemo'
}

const HTTP = axios.create({
  baseURL: hosts.std,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    Accept: 'application/json'
  }
})

export { HTTP, getURL, URL_TYPES, hosts, contexts }
